<template>
  <div class="w-100">
    <template
      v-if="
        (merchant.id &&
          merchant.merchant_type == 'hotel' &&
          no_loading_screen) ||
        (merchant.id &&
          merchant.is_special_merchant &&
          current_route.meta.is_special_merchant)
      ">
      <router-view></router-view>
    </template>
    <template v-else>
      <div class="py-4" v-if="is_load">
        <loader></loader>
      </div>
      <template v-else>
        <warning-box v-if="error != ''" title="Something wrong" :body="error">
        </warning-box>
        <template v-else>
          <div class="w-100" v-if="no_wrapper_page">
            <router-view></router-view>
          </div>
          <div class="w-100" v-else>
            <template
              v-if="
                merchant.merchant_type == 'ticket' && merchant.theme == 'ZOO'
              ">
              <router-view />
            </template>
            <b-row class="justify-content-center" no-gutters v-else>
              <b-col
                cols="12"
                sm="8"
                md="6"
                lg="4"
                xl="4"
                class="fit-to-screen bg-white"
                :class="{ 'pb-60px': merchant.merchant_type == 'ticket' }">
                <router-view />
                <bottom-navbar v-if="merchant.merchant_type == 'ticket'" />
              </b-col>
            </b-row>
          </div>
        </template>
      </template>
    </template>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import { get } from '@/services/index.js';
import WarningBox from '@/components/general/WarningBox';
import BottomNavbar from '@/components/general/BottomNavbar';
import currency from '@/data/currency';
import '@/assets/fonts/iconsmind/style.css';
import '@/assets/fonts/simple-line-icons/css/simple-line-icons.css';
import moment from 'moment';
import Vue from 'vue';
import ZooBG from '@/assets/img/content/bali-bird-park-bg.jpg';
import config from '../../config';
import { applyResolvedTitle, BRAND_FALLBACK } from '../../utils/titleService';
import { trackPageViewAfterDataLoaded } from '../../utils/analytics';

export default {
  metaInfo() {
    if(!this.merchant.id) return {}
    return {
      link: [
        { rel: 'shortcut icon', href: this.merchant.favicon_url },
      ]
    };
  },
  components: {
    WarningBox,
    BottomNavbar,
  },
  data() {
    return {
      is_load: true,
      error: '',
      merchant: {},
      currency: currency,
    };
  },
  computed: {
    ...mapGetters([
      'getTicketCart',
      'getMerchant',
      'getTicketFilter',
      'getCurrency',
      'getBaseRate',
      'getCurrentLanguage',
      'getBeTxPayment',
      'getUpsellRef',
      'getConciergeAuth',
      'isNotLogin',
      'getIsConciergeAuthWithoutPinToken',
      'getCompanyType',
      'getClientUid',
      'isLoggedIn'
    ]),
    router_merchant_code() {
      return window.IS_MERCHANT_CODE_HIDE ? window.MERCHANT_CODE : this.$route.params.merchant_code;
    },
    custom_color() {
      let return_data = {
        primary_color: '#79A33A',
        button_color_1: '#FF6144',
        text_color_1: '#FF6144',
      };
      if (
        this.merchant.id &&
        (this.merchant.merchant_type == 'hotel' ||
          this.merchant.merchant_type == 'restaurant')
      ) {
        return_data = {
          primary_color: this.merchant.primary_color,
          button_color_1: this.merchant.button_color_1,
          text_color_1: this.merchant.text_color_1,
        };
      }
      return return_data;
    },
    current_route() {
      return this.$route;
    },
    no_wrapper_page() {
      let validate_from_route = this.current_route.meta.no_wrapper;
      let validate_merchant_hotel =
        this.merchant.id && this.merchant.merchant_type == 'hotel';
      return validate_from_route && validate_merchant_hotel;
    },
    no_loading_screen() {
      return this.current_route.meta.no_loading;
    },
    is_mobile_view() {
      return window.innerWidth > 768 ? false : true;
    },
  },
  watch: {
    $route(to, from) {
      this.validatePageModuleType();
      let cart_ticket =
        this.current_route.name == 'Cart' &&
        this.merchant.merchant_type == 'ticket' &&
        this.getTicketCart.qty > 0;
      if (
        from.path != to.path &&
        (to.meta.need_reload_merchant || cart_ticket)
      ) {
        this.loadFirstData();
      }
    },
  },
  mounted() {
    this.loadFirstData();
  },
  methods: {
    ...mapActions([
      'setMerchant',
      'ticketResetItemCart',
      'ticketSetBookingDateCart',
      'ticketSetFilterTransport',
      'setLanguage',
      'logout',
      'setUser'
    ]),
    ...mapMutations([
      'setCurrency',
      'setBaseRate',
      'resetBeFilter',
      'resetBECart',
      'setMetaTitleTemplate',
      'setBeTxPayment',
      'setAgentId',
      'setUpsellRef',
      'setMerchantTimezone',
      'resetRestaurantOrder',
      'setConciergeReservation',
      'setCompanyType',
      'resetAllDataHotel',
      'resetAllDataMarketing',
      'resetAllDataRestaurant',
      'resetAllDataTicket',
      'resetAllDataGeneral',
      'setMerchantLoad',
      'resetAllDataConcierge',
      'checkAndResetRestaurantDelivery',
      'setClientUid',
      'setLoadingPage'
    ]),
    loadFirstData() {
      this.is_load = true;
      this.setLoadingPage(false)
      this.setMerchantLoad(true);
      this.error = '';
      Promise.all([this.loadMerchant()])
        .then(res => {
          if(res[0] !== 'reload'){
            this.generateClientUid();
            this.configMerchant();
          }
        })
        .catch((err) => {
          console.log("LINE : ", err);
          this.error = err
        })
        .finally(() => {
          this.is_load = false;
          this.setMerchantLoad(false);
        });
    },
    generateClientUid() { //For meta pixel & capi : external_id
      if(this.$isEmpty(this.getClientUid)){
        this.setClientUid(this.$createUUID())
      }
    },
    loadMerchant() {
      return new Promise((success, fail) => {
        get('CORE', `merchant/${this.router_merchant_code}`).then(
          (response_core) => {
            let res = response_core.data;
            if (res.success) {
              const validWhiteLabelDomain = this.valditeWhiteLabelDomain(res.data);
              if(validWhiteLabelDomain === ''){
                if (res.data.merchant_type == 'ticket') {
                  this.merchant = res.data;
                  // let bali_bird_park_id = '3495da31-cb20-4a50-89ef-b37059020870'
                  // let merchant_id_special = this.$app_env == 'dev' ? 'ba4cf44f-8495-4dbd-8389-738fb9ad3c2a' : 'cf0a9e4e-3530-4a5c-a31c-c26599a20c31'
                  let mookiland = 'cf0a9e4e-3530-4a5c-a31c-c26599a20c31';
                  let egobike = 'c84448e3-8021-400f-ba6e-67ae007cc19f';
                  let merchant_id_special = () => {
                    if (this.$app_env == 'dev') {
                      let monkey_forest =
                        this.merchant.id ==
                        'ba4cf44f-8495-4dbd-8389-738fb9ad3c2a';
                      let island_express =
                        this.merchant.id ==
                        '65615642-8e34-409d-a3da-16532e42f25a';
                      return monkey_forest || island_express ? true : false;
                    } else {
                      return this.merchant.id == mookiland || egobike;
                    }
                  };
                  if (merchant_id_special()) {
                    this.merchant.is_special_merchant = true;
                  } else {
                    this.merchant.is_special_merchant = false;
                  }

                  if(!(this.merchant.code === config.MERCHANT_CUSTOM.balibirdpark && this.$route.name === 'MerchantHome')){
                    success();
                  }else{
                    this.$router.push({
                      name: 'MerchantTicketInfo'
                    })
                    success("reload");
                  }
                } else {
                  let BASE_URL_API = 'CORE_HOTEL'; //SET DEFAULT TO HOTEL TYPE
                  if (res.data.merchant_type == 'restaurant') {
                    BASE_URL_API = 'CORE_RESTO';
                  }
                  get(BASE_URL_API, `merchant/${this.router_merchant_code}`).then(
                    (response_sub) => {
                      let res_sub = response_sub.data;
                      if (res_sub.success) {
                        this.merchant = res_sub.data;
                        success();
                      } else {
                        fail(res_sub.message);
                      }
                    }
                  );
                }
              }else{
                fail(validWhiteLabelDomain);
              }
            } else {
              fail(res.message);
            }
          }
        );
      });
    },
    valditeWhiteLabelDomain(merchant){
      const { is_white_label, domain_url } = merchant;
      try {
        if(!is_white_label) return "";
        const customUrl = new URL(domain_url);
        const currentUrl = window.location.origin;
        if(currentUrl === customUrl.origin) return "";
        if (customUrl.host !== config.HOST_DOMAIN) return this.$openLink(`${domain_url}${window.location.pathname}`);
        return "";
      } catch (e) {
        console.error("Invalid CUSTOM URL:", domain_url);
        return "";
      }
    },
    configMerchant() {
      let set_merchant_type = 'fill';
      if (this.getMerchant.id && this.getMerchant.id == this.merchant.id) {
        set_merchant_type = 'update';
      }
      if (set_merchant_type == 'fill') {
        this.resetAllDataVuex();
      }
      this.setMerchant({
        type: set_merchant_type,
        data: this.merchant,
      });
      if(this.$isNotEmptyV2(this.merchant.booking_engine_custom_css)) this.setupCustomCss(this.merchant.booking_engine_custom_css);

      const pageTitle = document.title;
      if(pageTitle && pageTitle === BRAND_FALLBACK){
        applyResolvedTitle({router: this.$router, title: this.merchant.name, useTemplate: false, trackFn: () => {
          trackPageViewAfterDataLoaded()
        }})
      }
      
      this.setupBaseColor();
      this.setupMeta();
      this.setupLanguage();
      this.setupTimeZone();
      this.setupCurrency();
      if (this.merchant.merchant_type == 'hotel') {
        this.setupIntegration();
        this.validatePageModuleType();
        this.setupUpselling();
        if(this.$useCommunityAuth() && this.isLoggedIn) this.getProfile();
      }
      if (this.merchant.merchant_type == 'ticket') {
        this.setupTicketCart();
        this.setupIntegration();
      }
      if (this.merchant.merchant_type == 'restaurant') {
        this.checkAndResetRestaurantDelivery();
      }
      if (
        this.merchant.merchant_type == 'ticket' &&
        this.merchant.theme &&
        this.merchant.theme == 'ZOO'
      ) {
        const body = document.querySelector('body');
        body.classList.remove('bg-custom-light');
        let custom_bg = ZooBG;
        body.style.backgroundImage = `url("${custom_bg}")`;
        body.style.backgroundSize = 'cover';
        body.style.backgroundAttachment = 'fixed';
      } else {
        const body = document.querySelector('body');
        body.style = {};
        body.classList.add('bg-custom-light');
      }
    },
    async getProfile(){
      try {
        const apiResponse = await get('BASE', "auth/profile");
        const { user = null } = apiResponse.data;
        if(this.$isNotEmptyV2(user)) this.setUser(user);
      } catch (error) {
        console.log("ERROR : getProfile => ", error.message)
      }
    },
    resetAllDataVuex() {
      this.resetAllDataHotel();
      this.resetAllDataMarketing();
      this.resetAllDataRestaurant();
      this.resetAllDataTicket();
      this.resetAllDataGeneral();
      this.resetAllDataConcierge();
    },
    setupMeta() {
      let titleTemplate = `%s | ${this.merchant.name}`;
      this.setMetaTitleTemplate(titleTemplate);
    },
    setupLanguage() {
      const { merchant_type, language } = this.merchant;

      if (merchant_type === 'restaurant') {
        this.setLanguage('en');
        return;
      }

      if (language.length > 1) {
        const selectedLanguage = language.find(
          (lang) => lang.iso_code == this.getCurrentLanguage
        );
        if (this.$isNotEmptyV2(selectedLanguage)) return;

        const defaultLanguage = language.find((lang) => lang.is_default);
        let selectedDefaultLanguage = this.$isNotEmptyV2(defaultLanguage)
          ? defaultLanguage
          : language[0];

        this.setLanguage(selectedDefaultLanguage.iso_code);
        window.location.reload();
        return;
      }

      if (
        language.length == 1 &&
        this.getCurrentLanguage != language[0].iso_code
      ) {
        this.setLanguage(language[0].iso_code);
        window.location.reload();
        return;
      }
    },
    setupTimeZone() {
      let params =
        this.merchant.timezone == null ? 'local' : this.merchant.timezone;
      this.setMerchantTimezone(params);
    },
    setupIntegration() {
      const { 
        google_analytics_id, 
        google_tag_manager_id,
        what_converts_url,
        meta_pixel_id
      } = this.merchant;
      
      if (this.$isNotEmptyV2(google_analytics_id)) {
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${google_analytics_id}`;
        document.head.insertBefore(script, document.head.firstChild);

        window.dataLayer = window.dataLayer || [];

        function gtag() {
          dataLayer.push(arguments);
        }
      
        gtag('js', new Date());
        gtag('config', google_analytics_id);
        
        Vue.prototype.$gtag = function (...args) {
          gtag(...args);
        };
      }
      if (this.$isNotEmptyV2(google_tag_manager_id)) {
        const tag = 'script';
        const dataLayerName = 'dataLayer';
        const gtmId = google_tag_manager_id; // Replace with your actual GTM ID

        // Initialize dataLayer and push initial GTM event
        window[dataLayerName] = window[dataLayerName] || [];
        if (!window.gtmInjected) {
          window[dataLayerName].push({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js',
          });

          // inject script...
          window.gtmInjected = true; // prevent duplicate
        }

        // Create GTM <script> tag
        const gtmScript = document.createElement(tag);
        gtmScript.async = true;
        const layerParam = dataLayerName !== 'dataLayer' ? `&l=${dataLayerName}` : '';
        gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}${layerParam}`;

        // Insert before the first <script> tag
        const firstScript = document.getElementsByTagName(tag)[0];
        firstScript.parentNode.insertBefore(gtmScript, firstScript);
        console.log('[DEBUG] GTM injected with ID:', gtmId, 'on url:', window.location.href);
      }
      if (this.$isNotEmptyV2(what_converts_url)) {
        let scriptHeader = document.createElement('script');
        scriptHeader.src = what_converts_url;
        let header = document.getElementsByTagName('head')[0];
        header.insertBefore(scriptHeader, header.firstChild);
      }
      if (this.$isNotEmptyV2(meta_pixel_id)) {
        const META_PIXEL_ID = meta_pixel_id;
        let scriptHeader = document.createElement('script');
        let scriptHeaderVal = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init', '${META_PIXEL_ID}');`;
        scriptHeader.append(scriptHeaderVal);
        let header = document.getElementsByTagName('head')[0];
        header.appendChild(scriptHeader);

        let noscript = document.createElement('noscript');
        let noscriptVal = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1"/>`;
        noscript.append(noscriptVal);
        header.appendChild(noscript);

        window.fbqReady = true
        
        if(window.fbqQueue){
          window.fbqQueue.forEach(data => {
            this.$sendEventMetaConversionsAPI('PageView');
          });
        }
      }
    },
    setupCurrency() {
      let default_currency = this.getMerchant.base_currency_code;

      if (
        Object.keys(this.getCurrency).length == 0 ||
        Object.keys(this.getCurrency).length < 6
      ) {
        let selected_currency = this.currency.find(
          (x) => x.code == default_currency
        );
        this.setCurrency(selected_currency);
        this.setBaseRate({ a: 1, b: 1 });
      } else {
        if (this.getCurrency.code != default_currency) {
          this.$convertCurrency(this.getCurrency.code);
        } else {
          this.setBaseRate({ a: 1, b: 1 });
        }
      }
    },
    validatePageModuleType() {
      let module_type = this.$route.meta.module_type;
      let is_general_page = module_type == 'merchant-general';
      let is_merchant_hotel = this.merchant.merchant_type == 'hotel';
      let is_be_page = module_type == 'merchant-hotel-booking_engine';
      let is_merchant_use_be = this.merchant.use_booking_engine;
      let is_concierge_page = module_type == 'merchant-hotel-concierge';
      let is_merchant_use_concierge = this.merchant.use_concierge_app;

      if (
        !is_general_page &&
        is_merchant_hotel &&
        ((is_be_page && !is_merchant_use_be) ||
          (is_concierge_page && !is_merchant_use_concierge))
      ) {
        this.$router.push({
          name: 'MerchantHome',
          params: {
            merchant_code: this.merchant.code,
          },
        });
      }
    },
    setupCustomCss(cssString){
      const styleElement = document.createElement("style");
      styleElement.type = "text/css";
      styleElement.appendChild(document.createTextNode(cssString));

      const head = document.head;
      if (head.firstChild) {
        head.insertBefore(styleElement, head.firstChild);
      } else {
        head.appendChild(styleElement);
      }
    },
    setupBaseColor() {
      document
        .querySelector(':root')
        .style.setProperty(
          '--merchant-primary-color',
          this.custom_color.primary_color
        );
      document
        .querySelector(':root')
        .style.setProperty(
          '--merchant-primary-color-alpha',
          `${this.custom_color.primary_color}30`
        );
      document
        .querySelector(':root')
        .style.setProperty(
          '--merchant-primary-color-alpha-15',
          `${this.custom_color.primary_color}15`
        );
      document
        .querySelector(':root')
        .style.setProperty(
          '--merchant-button-color',
          this.custom_color.button_color_1
        );
      document
        .querySelector(':root')
        .style.setProperty(
          '--merchant-text-color',
          this.custom_color.text_color_1
        );
    },
    setupUpselling() {
      let upsell_valid = {
        route_params:
          this.$route.query.campaign || this.$route.query.guest_journey,
        rsv_id: this.$route.query.reservation_id,
        ref_id: this.getUpsellRef.id != '',
        ref_time: this.$checkDuration(
          this.getUpsellRef.created_at,
          24,
          'hours'
        ),
        type: this.getUpsellRef.module != this.$route.meta.module_type,
      };
      if (upsell_valid.route_params) {
        let params_vuex = {
          id: this.$route.query.campaign
            ? this.$route.query.campaign
            : this.$route.query.guest_journey,
          type: this.$route.query.campaign ? 'CAMPAIGN' : 'GUEST_JOURNEY',
          reservation_id: '',
          module: this.$route.meta.module_type,
        };
        if (upsell_valid.rsv_id != undefined) {
          params_vuex.reservation_id = upsell_valid.rsv_id;
          if (this.getConciergeAuth.detail_id != '') {
            this.getReservationDetail(upsell_valid.rsv_id)
              .then((rsv_res) => {
                let vuex_same_with_pms_detail_id =
                  rsv_res.pms_detail_id == this.getConciergeAuth.detail_id;
                let vuex_same_with_rsv_id =
                  upsell_valid.rsv_id == this.getConciergeAuth.detail_id;
                if (!(vuex_same_with_pms_detail_id || vuex_same_with_rsv_id)) {
                  this.$logout();
                  this.setConciergeReservation(rsv_res);
                }
              })
              .catch((err) => console.log(err));
          }
        }
        this.setUpsellRef(params_vuex);
      } else if (
        upsell_valid.ref_id &&
        (upsell_valid.ref_time || upsell_valid.type)
      ) {
        this.setUpsellRef();
      }
    },
    getReservationDetail(id) {
      return new Promise((success, fail) => {
        get('CONCIERGE', `reservation/${id}`, {
          merchant_id: this.getMerchant.id,
        }).then((response) => {
          if (response.data.success) {
            success(response.data.data);
          } else {
            fail(response.data.message);
          }
        });
      });
    },
    setupTicketCart() {
      let today = this.$startDate(moment);
      let visitdate = this.$startDate(this.getTicketCart.visit_date);
      if (
        this.getMerchant.merchant_category_name == 'ACTIVITIES' &&
        moment(visitdate).isBefore(today)
      ) {
        this.ticketResetItemCart();
        this.ticketSetBookingDateCart(today);
      } else if (
        this.getMerchant.merchant_category_name == 'TRANSPORT' &&
        moment(this.getTicketFilter.departure).isBefore(today)
      ) {
        this.ticketResetItemCart();

        let filter = {
          trip_type: this.getTicketFilter.trip_type,
          from: this.getTicketFilter.from,
          to: this.getTicketFilter.to,
          departure: moment(today).toDate(),
          return: this.getTicketFilter.return,
        };
        if (moment(this.getTicketFilter.return).isBefore(today)) {
          filter.return = moment(today).add(1, 'd').toDate();
        }
        this.ticketSetFilterTransport({
          type: 'update',
          data: filter,
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/general/index.vue